import {Dispatch} from 'redux';
import {MeDto} from '../../../models/dtos/me.dto';
import {SessionStorage} from "../../../utilities/sessionStorage";
import {SET_ME} from './constants';
import {SetMeAction} from './types';

export const setMeAction = (payload?: MeDto): SetMeAction => {
  return {
    type: SET_ME,
    payload: payload,
  };
};

export const setMe = (me?: MeDto) => async (
  dispatch: Dispatch,
) => {
  if (!me) {
    SessionStorage.remove(SessionStorage.token);
  }
  dispatch(setMeAction(me));
};
